import { useReducer, useState } from 'react'
import Image from 'next/image'

import Button from '@/components/common/Button'
import Input from '@/components/common/Input'

import process from 'next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss'

const initialState = {
  error: null,
}

function errorReducer(state, action) {
  switch (action.type) {
    case 'SET_ERROR':
      return { ...state, error: action.payload }
    case 'CLEAR_ERROR':
      return { ...state, error: null }
    default:
      return state
  }
}


export default function ContactForm() {
  const [state, dispatch] = useReducer(errorReducer, initialState)
  const [isSuccess, setIsSuccess] = useState(false)
  const { error } = state
  const handleError = (error) => {
    dispatch({ type: 'SET_ERROR', payload: error })
  }
  const clearError = () => {
    dispatch({ type: 'CLEAR_ERROR' })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    clearError()
    const formData = new FormData(e.target)
    const data = {
      name: formData.get('Name'),
      phone: formData.get('Phone'),
      city: formData.get('City'),
    }
    console.log('data', data)
    console.log('error', error)
    let errorForm = null
    if (!data.name) errorForm = ({ ...errorForm, name: 'Hãy nhập Họ tên' })
    if (!data.phone) errorForm = ({ ...errorForm, phone: 'Hãy nhập Số điện thoại' })
    if (!data.city) errorForm = ({ ...errorForm, city: 'Hãy nhập Tỉnh thành' })
    if (errorForm) handleError(errorForm)
    if (!errorForm) {
      const sheetUrl = process.env.NEXT_PUBLIC_WEB_APP_URL
      try {
        await fetch(sheetUrl, {
          method: 'POST',
          body: formData,
          muteHttpExceptions: true,
        })
        setIsSuccess(true)
      } catch (error) {
        console.log(error)
      }
    }
  }

  return (
    <div
      id="tu-van"
      className="flex lg:mx-auto lg:mt-20 my-12 mx-[18px] bg-white shadow-light-shadow rounded-2xl  lg:w-[1200px] ">
      <div
        className="max-lg:mx-auto lg:p-8 px-[18px] py-6 flex flex-col gap-6 xl:w-[556px] lg:w-[540px] md:w-[704px] w-[394px]">
        {isSuccess ? (
          <div className="flex flex-col gap-4 m-auto items-center max-w-[394px]">
            <div className="relative size-[150px]">
              <Image src="./images/common/success-icon.png" alt="success" fill={true} />
            </div>
            <div className="flex flex-col gap-2 text-center">
              <div className="text-brand-navy text-2xl leading-9 font-bold">Gửi thông tin thành công!</div>
              <div className="text-text-secondary font-normal text-sm">Chúng tôi sẽ liên hệ với bạn trong 24h. Hoặc bạn
                có thể gọi tổng đài CSKH 19006522 để
                được hỗ trợ.
              </div>
            </div>
          </div>
        ) : (
          <>
            <div
              className="lg:w-[455px] text-brand-primary-850 lg:text-3xl text-2xl leading-9 font-bold md:text-left text-center">Hãy
              để
              lại thông tin, chúng tôi sẽ gọi cho bạn
            </div>
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col gap-6">
                <Input label="Họ tên" error={error?.name} name="Name" />
                {error?.name && <div className="-my-5 text-sm font-normal text-support-danger-500">{error.name}</div>}
                <Input label="Số điện thoại" error={error?.phone} name="Phone" />
                {error?.phone && <div className="-my-5 text-sm font-normal text-support-danger-500">{error.phone}</div>}
                <Input label="Tỉnh thành" error={error?.city} name="City" />
                {error?.city && <div className="-my-5 text-sm font-normal text-support-danger-500">{error.city}</div>}
                <Button>
                  Nhận tư vấn miễn phí
                </Button>
              </div>
            </form>
          </>
        )
        }

      </div>
      <div className="relative m-6 w-[596px] h-[384px]  lg:flex hidden">
        <Image src="./images/payment-ver2/get-info.png" alt="get-info" fill={true} />
      </div>
    </div>
  )
}
